// Single source of truth for routes and their localized slugs.
// Czech is primary (no language prefix); English/Slovak get a /en or /sk prefix
// AND a translated slug.
export const ROUTES = [
  { key: "home",     cs: "",                  en: "",           sk: "" },
  { key: "about",    cs: "o-summitu",         en: "about",      sk: "o-summite" },
  { key: "why",      cs: "proc-se-zucastnit", en: "why-attend", sk: "preco-sa-zucastnit" },
  { key: "program",  cs: "program",           en: "program",    sk: "program" },
  { key: "themes",   cs: "temata",            en: "topics",     sk: "temy" },
  { key: "gala",     cs: "galavecer",         en: "gala",       sk: "galavecer" },
  { key: "caseStudies", cs: "pripadove-studie", en: "case-studies", sk: "pripadove-studie" },
  { key: "tickets",  cs: "vstupne",           en: "tickets",    sk: "vstupenky" },
  { key: "recap",    cs: "ohlednuti",         en: "recap",      sk: "ohliadnutie" },
  { key: "partners", cs: "partneri",          en: "partners",   sk: "partneri" },
  { key: "faq",      cs: "faq",               en: "faq",        sk: "faq" },
  { key: "media",    cs: "pro-media",         en: "for-media",  sk: "pre-media" },
  { key: "privacy",  cs: "ochrana-osobnich-udaju", en: "privacy-policy", sk: "ochrana-osobnych-udajov" },
];

// Top-level navigation items (order matters).
export const navKeys = ["home", "program", "themes", "tickets", "partners", "faq"];

const byKey = (key) => ROUTES.find((r) => r.key === key);

// Bare slug for a route key in a language (no prefix, no leading slash).
export const slugFor = (key, lang) => {
  const r = byKey(key);
  return r ? r[lang] || "" : "";
};

// Full localized path for a route key (with /en or /sk prefix, no trailing slash).
export const pathFor = (key, lang) => {
  const slug = slugFor(key, lang);
  const prefix = lang === "cs" ? "" : `/${lang}`;
  const p = slug ? `/${slug}` : "";
  return `${prefix}${p}` || "/";
};

// Parse a pathname into { lang, key }.
export const parsePath = (pathname) => {
  const parts = (pathname || "/").split("/").filter(Boolean);
  let lang = "cs";
  let rest = parts;
  if (parts[0] === "en" || parts[0] === "sk") {
    lang = parts[0];
    rest = parts.slice(1);
  }
  const slug = rest[0] || "";
  const r = ROUTES.find((x) => x[lang] === slug);
  return { lang, key: r ? r.key : "home" };
};
